"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributesFilterContainer = exports.default = void 0;
const react_1 = __importStar(require("react"));
const attributes_sidebar_section_component_1 = require("./attributes-sidebar-section.component");
const formal_attributes_1 = require("../../../formal-attributes");
const store_1 = require("../../../../store");
const AttributesFilterContainer = ({ searchTerm, }) => {
    const { actualAttributes } = (0, store_1.useRefinementsDataSelector)();
    const refinementsLoading = (0, store_1.useRefinementsLoadingSelector)();
    const { loadFormalAttributes, isLoading: isFormalAttributesLoading, } = (0, formal_attributes_1.useFormalAttributes)();
    const isAttributesLoading = refinementsLoading || isFormalAttributesLoading;
    (0, react_1.useEffect)(() => {
        if (actualAttributes === null || actualAttributes === void 0 ? void 0 : actualAttributes.length) {
            void loadFormalAttributes(actualAttributes);
        }
    }, [actualAttributes, loadFormalAttributes]);
    return (react_1.default.createElement(attributes_sidebar_section_component_1.AttributesSideBarSection, { searchTerm: searchTerm, isAttributesLoading: isAttributesLoading }));
};
const MemoizedAttributesFilterContainer = react_1.default.memo(AttributesFilterContainer);
exports.default = MemoizedAttributesFilterContainer;
exports.AttributesFilterContainer = MemoizedAttributesFilterContainer;
